// 期日超過トリアージの導出ロジック。依存ゼロの純関数。
// overdue = dueDate < 今日(ローカル YYYY-MM-DD) && status ∈ {todo,in_progress} && !deleted。

export type TriageGoalStatus = "todo" | "in_progress" | "done" | "dormant";

export interface TriageGoalLike {
  id: string;
  dueDate: string | null;
  status: TriageGoalStatus;
  deleted: boolean;
  sortOrder?: number;
  createdAt?: string;
}

export function overdueGoals<G extends TriageGoalLike>(goals: G[], todayIso: string): G[] {
  return goals
    .filter(
      (goal) =>
        !goal.deleted &&
        (goal.status === "todo" || goal.status === "in_progress") &&
        Boolean(goal.dueDate) &&
        goal.dueDate! < todayIso
    )
    .sort(
      (a, b) =>
        a.dueDate!.localeCompare(b.dueDate!) ||
        (a.sortOrder ?? 0) - (b.sortOrder ?? 0) ||
        (a.createdAt ?? "").localeCompare(b.createdAt ?? "") ||
        a.id.localeCompare(b.id)
    );
}
